import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpResponseBase, HttpErrorResponse } from '@angular/common/http'
import { catchError } from 'rxjs/operators/catchError';
import { _throw } from 'rxjs/observable/throw';
import { movieVM } from '../../models/movieVM';
import { AppConstants } from '../../constants/siteConstants';


@Injectable()
export class MovieInfoService {
  constructor(private http: HttpClient) { }

  getAll() {
    return this.http.get<any>(`${AppConstants.baseURL}/movie/bindMovies/`);
    //.toPromise()
    //  .catch(err => this.handleError(err));
  }

  getMoviesForVenues() {
    return this.http.get<any>(`${AppConstants.baseURL}/movie/moviesForVenue/`);
    //.toPromise()
    //  .catch(err => this.handleError(err));
  }

  getMovieCityVenues() {
    debugger;
    return this.http.get<any>(`${AppConstants.baseURL}/movie/movieCityVenues/`);
  }

  getVenueByMovieAndCity(cityId: string) {
    debugger;
    return this.http.get<any>(`${AppConstants.baseURL}/movie/moviesForVenuesByCity?cityId=` + cityId);
  }


  getById(id: number) {
    return this.http.get(`${AppConstants.baseURL}/users/` + id);
  }

  addMovie(movieModel: any) {
    // return this.http.post(`${AppConstants.baseURL}/movie/save`, movieModel);
    const uploadReq = new HttpRequest('POST', `${AppConstants.baseURL}/movie/save`, movieModel, {
      reportProgress: true,
    });



    return this.http.post(`${AppConstants.baseURL}/movie/save`, movieModel);
    //.subscribe(
    //  data => {
    //    console.log("Subscribe data", data);
    //  },
    //  (err: HttpErrorResponse) => {
    //    debugger;
    //    this.handleError(err);
    //    // console.log(err.message, JSON.parse(err.error).error.message);
    //  }
    //)


    //return this.http.request(uploadReq).subscribe((event) => {
    //  debugger;

    //  if (event.type === HttpEventType.UploadProgress) {
    //   // this.progress = Math.round(100 * event.loaded / event.total);
    //  }
    //  else if (event.type === HttpEventType.Response) {
    //   // this.message = event.body.toString();
    //  }
    //});

  }

  update(user: movieVM) {
    return this.http.put(`${AppConstants.baseURL}/users/` + user, user);
  }

  deleteVenue(id: number) {
    return this.http.delete(`${AppConstants.baseURL}/movie/venue/` + id);
  }
  deleteMultipleMultipleVenues(ids: any) {
    return this.http.post(`${AppConstants.baseURL}/movie/deleteMultipleVenues`, ids);
  }

  deleteMovie(id: number) {
    return this.http.delete(`${AppConstants.baseURL}/movie/deleteMovie/` + id);
  }
  deleteMultipleMovies(ids: any) {
    return this.http.post(`${AppConstants.baseURL}/movie/deleteMultipleMovies`, ids);
  }

  private handleError(error: HttpErrorResponse) {
    debugger;
    let errMsg = '';
    // Client Side Error
    if (error.error instanceof ErrorEvent) {
      errMsg = `Error: ${error.error.message}`;
    }
    else {  // Server Side Error
      errMsg = `Error Code: ${error.status},  Message: ${error.message}`;
    }
    // return an observable
    return _throw(errMsg);
  };

}



// WEBPACK FOOTER //
// ./src/app/services/movie/movie.service.ts